
exports.groupBy = (array, key) => {
  return array.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

exports.utf8_to_b64 = (str) => {
  return window.btoa(unescape(encodeURIComponent(str)))
}

exports.b64_to_utf8 = (str) => {
  return decodeURIComponent(escape(window.atob(str)))
}
